// React
import { Link } from 'react-router-dom';
import { Card, Col, Row } from 'reactstrap';
import React, { useCallback, useEffect } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { DeleteUsers, Users } from '../../store/actions';

// Components
import { FloatButton } from '../../components/floatButton';
import { PageWrapper } from '../../components/pageWrapper';
import { LoadingScreen } from '../../components/loading_screen';

// assets
import avatar from '../../assets/images/users/user-pic.jpg';
import { DropdownDatatable } from '../../components/dropdownDatatable';

const UserScreen = (props) => {
  const dispatch = useDispatch();

  const { users, success } = useSelector((state) => ({
    success: state.Users.success,
    users: state.Users.users,
  }));

  const handleDelete = (id) => {
    dispatch(DeleteUsers(id));
  };

  const handleEdit = useCallback((values) => {
    const { id } = values;
    props.history.push(`/configuracoes/usuarios/edit/${id}`);
  }, []);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: true,
      width: '30%',
      cell: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <img
                src={cell.photo || avatar}
                alt=""
                className="rounded-circle"
                width="30"
                height="30"
                style={{
                  marginRight: '10px',
                }}
              />
              <Link
                to={`/configuracoes/usuarios/edit/${cell.id}`}
                style={{
                  color: '#333',
                }}
              >
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
      selector: (row) => row.name,
    },
    {
      name: <span className="font-weight-bold fs-13">Email</span>,
      id: 'email',
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Usuário</span>,
      id: 'username',
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Perfil</span>,
      id: 'profile_name',
      selector: (row) => row.profile_name,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Último acesso</span>,
      id: 'last_login',
      selector: (row) => row.last_login,
      sortable: true,
    },
  ];

  useEffect(() => {
    dispatch(Users());
  }, [dispatch, success]);

  return (
    <LoadingScreen loading={!users} titleMetaTag={'Usuários'}>
      <PageWrapper title={'Usuários'}>
        <Row>
          <Col xs={12}>
            <div id="table-gridjs">
              <Card>
                <DropdownDatatable
                  keysSearch={['name', 'cpf', 'profile_name']}
                  title="Usuários"
                  titleButton="Nova proposta"
                  data={users ? users : []}
                  columns={columns}
                  pagination
                  persistTableHead
                  perPage={10}
                  isSearchRemote={false}
                  actions={[
                    {
                      id: 1,
                      name: 'edit',
                      label: 'Editar',
                      onPress: (cellProps) => handleEdit(cellProps),
                      icon: 'la-pen',
                      classNameColorIcon: 'primary',
                    },
                  ]}
                  handleDelete={(cellProps) => handleDelete(cellProps)}
                />
              </Card>
            </div>
          </Col>
        </Row>
        <FloatButton
          handleButton={() =>
            props.history.push(`/configuracoes/usuarios/novo`)
          }
        />
      </PageWrapper>
    </LoadingScreen>
  );
};

export default UserScreen;
